const selector = '.typography table';

function wrap(el, wrapper) {
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
}

export default function contentTablewrap() {
  if (document.querySelectorAll(selector)) {
    const tables = document.querySelectorAll(selector);

    tables.forEach((el) => {
      const tablediv = document.createElement('div');
      tablediv.classList.add('typography__table');
      wrap(el, tablediv);
    });
  }
}
